var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExtLinkNofill = function SvgExtLinkNofill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.078 2.344c-.52 0-.89-.371-.89-.89a.88.88 0 0 1 .89-.891h5.344c.482 0 .89.408.89.89v5.344a.88.88 0 0 1-.89.89c-.52 0-.89-.37-.89-.89V3.605L8.108 10.99a.813.813 0 0 1-1.224 0c-.371-.334-.371-.89 0-1.261l7.385-7.385zM.688 3.828c0-1.113.927-2.078 2.078-2.078h4.156c.482 0 .89.408.89.89a.88.88 0 0 1-.89.891H2.766a.293.293 0 0 0-.297.297V15.11c0 .186.111.297.297.297h11.28a.293.293 0 0 0 .298-.297v-4.156c0-.482.37-.89.89-.89.483 0 .891.408.891.89v4.156c0 1.15-.965 2.079-2.078 2.079H2.766a2.075 2.075 0 0 1-2.078-2.079z"
  })));
};
export default SvgExtLinkNofill;